import Connector from '../../agent';
import { AxiosError, AxiosResponse } from 'axios';
import { UserDTO } from './dto/UserDTO';
import { api } from '../../agent';

export function getUserV2(): Promise<UserDTO> {
  return api.get(`user`).then((response: { data: UserDTO }) => response.data);
}
